import Badge from "@visa/vds/badge";
import ButtonIcon from "@visa/vds/button-icon";
import Icon from "@visa/vds/icon";
import Tooltip from "rc-tooltip";
import "rc-tooltip/assets/bootstrap.css";
import React from "react";
const PostClassification = (props) => {
  return (
    <>
      <div className="library-classification">
        <div className="library-classification-icon">
          <Icon name="category" resolution="tiny" />
        </div>
        <div className="library-classification-badge">
          <Badge type="status">
            {props.name}
            {props.classificationId === 3 && (
              <Tooltip
                placement="right"
                overlay={
                  <span>{props.productName ? props.productName : ""}</span>
                }
              >
                <ButtonIcon
                  ariaLabel="store-open"
                  className="btn-subscription-tooltip"
                  iconType="light-tiny"
                >
                  <Icon name="info" resolution="tiny" />
                </ButtonIcon>
              </Tooltip>
            )}
          </Badge>
        </div>
      </div>
    </>
  );
};

export default PostClassification;
